import {
  ADMIN_MY_PRODUCTS_AIVIDEO_RENDER,
  ADMIN_SETTINGS,
  PRODUCT_AI_VIDEO_PUBLIC,
  PRODUCT_PANNING_VIDEO_PUBLIC,
  PRODUCT_VIDEO_PUBLIC,
  SIGN_IN_ROUTE,
  SIGNUP_ROUTE,
} from '../../constants/routePathConstants';
import {
  AddAddonCart,
  GetAllCartProductList,
  createProductVideoPublicData,
  getProductVideoPublicData,
  getSubscriptionLinkedProductData,
  linkSubscriptionProductData,
  removeAllItemsFromCart,
  setClientSubscriptionPlans,
  apiUpdateProductAIVideoInfo,
  apiUpdateProductVideoInfo,
  apiUpdateProductVideoOrder,
  apiUpdateProductPanningVideoOrder,
  apiUpdateProductPanningVideoInfo,
  apiUploadProductPanningVideoInfo,
  apiDeleteProductPanningVideoInfo,
} from '../../api/subscription/subscription';
import {
  LINKED_PRODUCT_DATA,
  OFFER_PRICE_DATA,
  VIDEO_STATUS,
  navigateToUpgradePlan,
} from '../subscriptionComponents/subscriptionHelper';
import { LeftIcon, RightIcon } from '../../assets/icons';
import {
  PRODUCT_DETAILS_PAGE_LABEL,
  PRODUCT_PAGE_NAVIGATION_KEY,
  RENDER_STATUS,
  SETTINGS_TAB,
} from '../../constants/constants';
import React, { useEffect, useMemo, useState } from 'react';
import { errorToast, infoToast, successToast } from '../../helpers/toastHelper';
import {
  selectAddonsList,
  selectAvailableAIVideo,
  selectAvailableVideo,
  selectHighestPlanOrderId,
  selectUserActivePlanDetails,
  selectUserActivePlanSubscriptionOrderId,
  selectUserPlanList,
} from '../../redux/slicers/subscriptionSlicer';

import MenuDropdown from '../../common/MenuDropdown';
import ShareButton from './ShareButton';
import { ShowRenameModel, ShowVideoUploadModal } from './ShowRenameModel';
import { VideoSectionUI } from './VideoSectionUI';
import { VideoTabUI } from './VideoTabUI';
import { dispatcher } from '../../helpers/projectHelper';
import downloadjs from 'downloadjs';
import { fetchAllPages } from '../../helpers/apiHelper';
import modalStyles from '../../components/InfoDialog/InfoDialogUI.module.scss';
import { useCopyToClipboard } from 'react-use';
import { useInfoDialogaActions } from '../../hooks/useInfoDialogaActions';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useUserContext } from '../../contexts/UserContext';
import {
  isIphoneIOS,
  openFormInCaseOfNewOrgAndFreemiumUser,
  windowOpen,
} from '../../helpers/jsHelper';
import { apiPostImageOnPresignedData } from '../../helpers/api';
import { ModalArea } from '../../common/ModalButtonArea';
import { UploadWithItemListModal } from './UploadWithItemListModal';
import { Checkbox } from '../../common';
import useCurrentOrganizationInfo from '../../hooks/useCurrentOrganizationInfo';
import { selectPdpProductCountInfo } from '../../redux/slicers/productV2Slicer';
import { isPdpProduct } from '../NewProductUIV2/ShareButtonV2/helpers';

export const VideoTabShowcase = ({
  productId,
  productInfo,
  isPublicPage,
  productUnicodeId,
  productOrg,
  orgProductUniqueCodeId,
  refetchDetails,
  setAIVideoProcessingStatus,
  isPackProduct: _isPackProduct,
}) => {
  const { currentUser, isEditor, isOldSubscriptionUser, isPremiumUser, isGuestUser, isGuestLogin } =
    useUserContext();
  const { isFreemiumOrSelfServeUser, hideNewPlans, isFreemiumUser } = useCurrentOrganizationInfo();
  const { results: addonsList } = useSelector(selectAddonsList);

  const navigate = useNavigate();
  const [videoList, setVideoList] = useState([]);
  const [renameEnabled, setRenameEnabled] = useState(false);
  const [videoUploadModal, setVideoUploadModal] = useState(null);
  const [actionMenu, setActionMenu] = useState([]);

  const [activeTab, setActiveTab] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const pdpProductCountInfo = useSelector(selectPdpProductCountInfo);
  const pdpVideoCount = pdpProductCountInfo?.product_video || 0;
  // const [isVideoPackProduct, setIsVideoPackProduct] = useState(true);

  const setWindowDimensions = () => {
    if (+document?.documentElement?.clientWidth > 767) {
      setIsMobile(false);
    } else {
      setIsMobile(true);
    }
  };

  const getVideoProductUniqueCode = async () => {
    if (!activeTab || !isIphoneIOS()) return;
    window.$videoProductUniqueCode = await getVideoUniqueCode(activeTab.id, true);
  };

  useEffect(() => {
    if (currentUser) {
      getVideoProductUniqueCode();
    }
  }, [activeTab?.id]);

  useEffect(() => {
    window.$videoProductUniqueCode = null;
    setWindowDimensions();
    window.addEventListener('resize', setWindowDimensions);
    return () => {
      window.removeEventListener('resize', setWindowDimensions);
    };
  }, []);

  const { openInfoDialog, closeInfoDialog } = useInfoDialogaActions();
  const [state, copy] = useCopyToClipboard();

  const activePlan = useSelector(selectUserActivePlanDetails) || isOldSubscriptionUser();
  const availableVideoCount = useSelector(selectAvailableVideo);
  const availablePanningVideoCount = useSelector(selectAvailableVideo); // selectAvailablePanningVideo - TODO: check if we get the panning video count or not
  const availableAIVideoCount = useSelector(selectAvailableAIVideo);
  // const highestPlanOrder = useSelector(selectHighestPlanOrderId);
  // const activePlanOrder = useSelector(selectUserActivePlanSubscriptionOrderId);
  // const showUpgradeButton = highestPlanOrder > activePlanOrder;

  const getUserPlans = useSelector(selectUserPlanList);
  const isOldPremiumUser = isPremiumUser() && getUserPlans?.length === 0;

  const availableProductCount = useMemo(() => {
    return activeTab?.type === LINKED_PRODUCT_DATA.VIDEO
      ? availableVideoCount
      : activeTab?.type === LINKED_PRODUCT_DATA.PANNING_VIDEO
      ? availablePanningVideoCount
      : availableAIVideoCount;
  }, [activeTab, availableVideoCount, availablePanningVideoCount, availableAIVideoCount]);

  const filteredVideos = useMemo(
    () => [
      ...videoList.filter((a) => a?.type === LINKED_PRODUCT_DATA.VIDEO),
      ...videoList.filter((a) => a?.type === LINKED_PRODUCT_DATA.PANNING_VIDEO),
      ...videoList.filter((a) => a?.type === LINKED_PRODUCT_DATA.AI_VIDEO),
    ],
    [videoList]
  );

  const isPackProduct = useMemo(() => {
    return (
      _isPackProduct &&
      activeTab?.pack_organization &&
      filteredVideos?.find(
        (a) => a.id === activeTab?.id && a.type === LINKED_PRODUCT_DATA.PANNING_VIDEO
      )
    );
  }, [_isPackProduct, activeTab, filteredVideos]);

  const getVideos = async () => {
    const res = await fetchAllPages((page) => {
      return getSubscriptionLinkedProductData({
        type: LINKED_PRODUCT_DATA.VIDEO,
        isPublicPage: isPublicPage && !currentUser,
        params: {
          product_uuid: productUnicodeId,
          product_org: productOrg || currentUser?.organization,
          ...(isPublicPage && !currentUser && { is_preview: true }),
          page: page,
          ...(isIphoneIOS() && { ios_device_request: true }),
        },
      });
    });
    if (res && res?.results?.length > 0) {
      const list = res.results.map((a) => ({
        id: a?.id,
        name: a?.name || 'Video',
        sequence_number: +a?.sequence_number,
        url: a?.url || a?.file,
        mpd_file: a?.mpd_file,
        type: LINKED_PRODUCT_DATA.VIDEO,
        pack_organization: a?.pack_organization,
      }));

      return (
        list
          .filter((a) => Boolean(a.url || a.mpd_file))
          .sort((a, b) => a?.sequence_number - b?.sequence_number) || []
      );
    }
  };

  const getPanningVideos = async () => {
    const res = await fetchAllPages((page) => {
      return getSubscriptionLinkedProductData({
        type: LINKED_PRODUCT_DATA.PANNING_VIDEO,
        isPublicPage: isPublicPage && !currentUser,
        params: {
          product_uuid: productUnicodeId,
          product_org: productOrg || currentUser?.organization,
          ...(isPublicPage && !currentUser && { is_preview: true }),
          page: page,
          ...(isIphoneIOS() && { ios_device_request: true }),
        },
      });
    });
    if (res && res?.results?.length > 0) {
      const list = res.results.map((a) => ({
        id: a?.id,
        name: a?.name || 'Video',
        sequence_number: +a?.sequence_number,
        url: a?.url || a?.file,
        mpd_file: a?.mpd_file,
        type: LINKED_PRODUCT_DATA.PANNING_VIDEO,
        pack_organization: a?.pack_organization,
      }));

      return (
        list
          .filter((a) => Boolean(a.url || a.mpd_file))
          .sort((a, b) => a?.sequence_number - b?.sequence_number) || []
      );
    }
  };

  const getAIVideos = async () => {
    const res = await fetchAllPages((page) => {
      return getSubscriptionLinkedProductData({
        type: LINKED_PRODUCT_DATA.AI_VIDEO,
        isPublicPage: isPublicPage && !currentUser,
        params: {
          product_uuid: productUnicodeId,
          product_org: productOrg || currentUser?.organization,
          ...(isPublicPage && !currentUser && { is_preview: true }),
          page: page,
          ...(isIphoneIOS() && { ios_device_request: true }),
        },
      });
    });
    if (res && res?.results?.length > 0) {
      const list = res.results.map((a) => ({
        id: a?.id,
        name: a?.name || 'Video',
        sequence_number: +a?.sequence_number || 1,
        url: a?.file || a?.url,
        mpd_file: a?.mpd_file,
        type: LINKED_PRODUCT_DATA.AI_VIDEO,
        pack_organization: a?.pack_organization,
      }));

      setAIVideoProcessingStatus(list?.filter((a) => Boolean(a.url || a.mpd_file))?.length);

      return (
        list
          .filter((a) => Boolean(a.url || a.mpd_file))
          .sort((a, b) => a?.sequence_number - b?.sequence_number) || []
      );
    }
  };

  const getAllVideos = async () => {
    const response = await Promise.allSettled([getVideos(), getPanningVideos(), getAIVideos()]);
    const videos =
      response
        ?.filter((a) => a?.status === 'fulfilled')
        ?.map((a) => a?.value)
        ?.flat()
        ?.filter(Boolean) || [];

    setVideoList(videos);
    setActiveTab(videos?.find((a) => a.id === activeTab?.id) || videos?.[0]);
  };

  useEffect(() => {
    if (!productUnicodeId) return;
    getAllVideos();
    return () => {
      setVideoList([]);
      setActiveTab(null);
    };
  }, [productUnicodeId]);

  //   3 dot menu action
  const handleSelect = async (value, data) => {
    if (value?.value === PRODUCT_DETAILS_PAGE_LABEL.RENAME_VALUE) setRenameEnabled(true);
    if (value?.value === PRODUCT_DETAILS_PAGE_LABEL.UPLOAD_PANNING_VIDEO_VALUE) {
      setVideoUploadModal({ type: LINKED_PRODUCT_DATA.PANNING_VIDEO, action: 'add' });
    }
    if (value?.value === PRODUCT_DETAILS_PAGE_LABEL.EDIT_PANNING_VIDEO_VALUE) {
      setVideoUploadModal({ type: LINKED_PRODUCT_DATA.PANNING_VIDEO, action: 'edit' });
    }
    if (value?.value === PRODUCT_DETAILS_PAGE_LABEL.DELETE_PANNING_VIDEO_VALUE) {
      const video = filteredVideos?.find((a) => a.id === activeTab?.id);
      if (video) {
        openInfoDialog({
          title: 'Delete video',
          description: `Do you want to delete "${video.name}"`,
          buttonText: 'Delete',
          onButtonClick: async () => {
            const result = await apiDeleteProductPanningVideoInfo(video?.id);
            await getAllVideos();
            if (result?.status) {
              successToast('Video deleted successfully.');
            } else {
              errorToast('Unable to delete video. Please try again later.');
            }
            refetchDetails?.();
          },
          cancelButtonText: 'Cancel',
        });
      }
    }
    if (value?.value === PRODUCT_DETAILS_PAGE_LABEL.EDIT_VALUE) {
      if (productInfo?.final_render_status?.status !== RENDER_STATUS.STATUS_DONE) {
        infoToast('Please wait. Video render is currently in processing.');
        return;
      }

      open(ADMIN_MY_PRODUCTS_AIVIDEO_RENDER.replace(':id', productId));
    }
  };
  const action3DotMenu = useMemo(
    () =>
      [
        {
          label: PRODUCT_DETAILS_PAGE_LABEL.RENAME_LABEL,
          value: PRODUCT_DETAILS_PAGE_LABEL.RENAME_VALUE,
          icon: null,
          permissionsRequired: false,
          disabled: filteredVideos.length === 0,
        },
        {
          label: PRODUCT_DETAILS_PAGE_LABEL.UPLOAD_PANNING_VIDEO_LABEL,
          value: PRODUCT_DETAILS_PAGE_LABEL.UPLOAD_PANNING_VIDEO_VALUE,
          icon: null,
          permissionsRequired: false,
        },
        activeTab?.type === LINKED_PRODUCT_DATA.PANNING_VIDEO
          ? [
              {
                label: PRODUCT_DETAILS_PAGE_LABEL.EDIT_PANNING_VIDEO_LABEL,
                value: PRODUCT_DETAILS_PAGE_LABEL.EDIT_PANNING_VIDEO_VALUE,
                icon: null,
                permissionsRequired: false,
              },
              {
                label: PRODUCT_DETAILS_PAGE_LABEL.DELETE_PANNING_VIDEO_LABEL,
                value: PRODUCT_DETAILS_PAGE_LABEL.DELETE_PANNING_VIDEO_VALUE,
                icon: null,
                permissionsRequired: false,
              },
            ]
          : null,
        activeTab?.type === LINKED_PRODUCT_DATA.AI_VIDEO
          ? {
              label: PRODUCT_DETAILS_PAGE_LABEL.EDIT_LABEL,
              value: PRODUCT_DETAILS_PAGE_LABEL.EDIT_VALUE,
              icon: null,
              permissionsRequired: false,
            }
          : null,
      ]
        .flat()
        .filter(Boolean),
    [activeTab, filteredVideos]
  );

  // manage order
  const handleUpdateOrder = (value, type = LINKED_PRODUCT_DATA.VIDEO) => {
    if (isEditor) {
      if (value?.newIndex || value?.newIndex === 0) {
        const formData = new FormData();
        filteredVideos
          .filter((a) => a.type === type)
          .map((a, index) => {
            formData.append('id', a?.id);
            formData.append('sequence_number', index + 1);
          });
        apiUpdateProductVideoOrder(formData);
      }
    }
  };

  // share action menu
  async function handleEnabled() {
    if (!activeTab) return;

    const formData = new FormData();
    formData.append(
      'type',
      activeTab.type === LINKED_PRODUCT_DATA.VIDEO
        ? LINKED_PRODUCT_DATA.VIDEO
        : activeTab.type === LINKED_PRODUCT_DATA.PANNING_VIDEO
        ? LINKED_PRODUCT_DATA.PANNING_VIDEO
        : LINKED_PRODUCT_DATA.AI_VIDEO
    );
    formData.append('is_link', true);
    formData.append('product_id', productId);
    formData.append('model_obj_id', activeTab.id);

    setLoading(true); // (prev) => [...prev, activeTab.id]);
    const res = await linkSubscriptionProductData(formData);
    if (res?.status) {
      successToast(res?.message);
    }
    dispatcher(setClientSubscriptionPlans());
    refetchDetails?.();
    await getAllVideos();
    setLoading(false); // (prev) => [...prev.filter((a) => a !== activeTab.id)]);
  }

  async function getVideoUniqueCode(id, stopLoader) {
    let productUniqueCode = null;

    !stopLoader && setLoading(true); // (prev) => [...prev, activeTab.id]);
    const response = await getProductVideoPublicData(
      `product=${productInfo?.id}&model_obj_id=${activeTab.id}`
    );

    if (response?.results?.length > 0) {
      productUniqueCode = response?.results?.[0]?.unique_code;
    } else {
      const formData = new FormData();
      formData.append('product', productInfo?.id);
      formData.append('model_obj_id', activeTab.id);
      const res = await createProductVideoPublicData(formData);

      if (res?.status) {
        productUniqueCode = res?.data?.unique_code;
      }
    }
    setLoading(false); // (prev) => [...prev.filter((a) => a !== activeTab.id)]);

    return productUniqueCode;
  }

  async function handleCopy() {
    if (!activeTab) return;

    const productUniqueCode =
      activeTab.type === LINKED_PRODUCT_DATA.AI_VIDEO
        ? orgProductUniqueCodeId
        : isIphoneIOS()
        ? window.$videoProductUniqueCode
        : await getVideoUniqueCode(activeTab.id);

    if (!productUniqueCode) {
      errorToast('Unable to copy. Please try again later.');
      return;
    }

    const path =
      activeTab.type === LINKED_PRODUCT_DATA.VIDEO
        ? PRODUCT_VIDEO_PUBLIC
        : activeTab.type === LINKED_PRODUCT_DATA.PANNING_VIDEO
        ? PRODUCT_PANNING_VIDEO_PUBLIC
        : PRODUCT_AI_VIDEO_PUBLIC;

    const url = window.location.origin + path.replace(':id', productUniqueCode);
    copy(url);
    successToast('Link Copied');
  }

  async function handleEmbedding() {
    if (!activeTab) return;

    const productUniqueCode =
      activeTab.type === LINKED_PRODUCT_DATA.AI_VIDEO
        ? orgProductUniqueCodeId
        : isIphoneIOS()
        ? window.$videoProductUniqueCode
        : await getVideoUniqueCode(activeTab.id);

    if (!productUniqueCode) {
      errorToast('Unable to copy. Please try again later.');
      return;
    }

    const path =
      activeTab.type === LINKED_PRODUCT_DATA.VIDEO
        ? PRODUCT_VIDEO_PUBLIC
        : activeTab.type === LINKED_PRODUCT_DATA.PANNING_VIDEO
        ? PRODUCT_PANNING_VIDEO_PUBLIC
        : PRODUCT_AI_VIDEO_PUBLIC;

    const embedLink = window.location.origin + path.replace(':id', productUniqueCode);
    const iframeCode = `<iframe style="border: none;" src="${embedLink}" title="${productInfo?.name}" width="100%" height="700px" allowfullscreen></iframe>`;
    copy(iframeCode);
    successToast('Embed Link Copied');
  }

  async function handleDownload() {
    if (!activeTab) return;

    const video = filteredVideos.find((a) => a.id === activeTab.id); // || window.videoURL;
    if (!video) {
      errorToast('Unable to download. Please try again later.');
      return;
    }
    setLoading(true); // (prev) => [...prev, activeTab.id]);
    return new Promise((resolve, reject) => {
      var x = new XMLHttpRequest();
      x.open('GET', video?.url, true);
      x.responseType = 'blob';
      x.onload = function (e) {
        setLoading(false); // (prev) => [...prev.filter((a) => a !== activeTab.id)]);
        downloadjs(e.target.response, `${video?.name}_${productInfo.name}.mp4`);
        resolve(undefined);
      };
      x.send();
    });
  }

  const buyVideo = async () => {
    await dispatcher(GetAllCartProductList());
    const addonsItem = addonsList?.find(
      ({ basemodeltype }) => basemodeltype === OFFER_PRICE_DATA[activeTab.type].baseModelType
    );
    let payload = {
      subscription_price: addonsItem?.id || OFFER_PRICE_DATA[activeTab.type].product_id,
      quantity: 1,
    };

    await removeAllItemsFromCart();

    const response = await AddAddonCart(payload, 'add');
    if (response?.status) {
      closeInfoDialog();

      let tab = SETTINGS_TAB.ADD_ONS;
      if (isFreemiumOrSelfServeUser) {
        tab = SETTINGS_TAB.PLANS;
      }

      windowOpen(
        `${ADMIN_SETTINGS}?activeTab=${tab}&checkout=true&is_one_time=true&referrer=${window.location.href}`,
        '_blank'
      );
    }
  };

  const handleShowPopup = () => {
    if (isFreemiumUser) {
      openFormInCaseOfNewOrgAndFreemiumUser();
      return;
    } else {
      navigateToUpgradePlan({ browsePlan: true, newTab: true, referrer: window.location.href });
    }
  };

  const handleShareForUse = () => {
    if (isPdpProduct()) {
      if (!pdpVideoCount) {
        openFormInCaseOfNewOrgAndFreemiumUser();
        return;
      }
      return;
    }
    if (hideNewPlans) {
      // open enterprise form in case of freemium user whose org is created after 10th Feb 2025
      openFormInCaseOfNewOrgAndFreemiumUser();
      return;
    }
    let title = 'Add item';
    let description = '';
    let buttonText = '';
    let buttonText2 = '';
    let onButtonClick = null;
    let onButtonClick2 = null;
    if (isOldPremiumUser && availableProductCount === 0) {
      title = 'Buy add on';
      buttonText = 'Buy';
      description = 'This item will be added on top of your existing subscription (if any).';
      onButtonClick = buyVideo;
    } else if (!activePlan && availableProductCount === 0) {
      buttonText = 'View plans';
      buttonText2 = 'Buy item';
      description =
        'You currently do not have an active subscription. Please purchase a subscription plan or buy this item separately.';
      onButtonClick = () => handleShowPopup();
      onButtonClick2 = buyVideo;
    } else if (availableProductCount === 0) {
      buttonText = 'Upgrade plan';
      buttonText2 = 'Buy item';
      description =
        'You do not have this item. Please upgrade your subscription plan or buy this item separately.';
      onButtonClick = () => handleShowPopup();
      onButtonClick2 = buyVideo;
    } else {
      return null;
    }

    openInfoDialog({
      title: title,
      description: description,
      buttonText: buttonText,
      onButtonClick: onButtonClick,
      buttonText2: buttonText2,
      onButtonClick2: onButtonClick2,
      btnContainerClass: 'align-items-center',
      addOrSeparator: false,
      designV2: true,
      closeable: false,
      designV2Props: {
        fillBtnClassName: modalStyles.fillBtn,
        okBtnClassName: modalStyles.btnLink,
      },
    });
  };

  const isVideoEnabled = useMemo(
    () =>
      activeTab?.type === LINKED_PRODUCT_DATA.VIDEO
        ? pdpVideoCount ? true : Array.isArray(productInfo?.video_status)
          ? productInfo?.video_status?.find((a) => a?.object_id === activeTab?.id)
          : productInfo?.video_status
        : activeTab?.type === LINKED_PRODUCT_DATA.PANNING_VIDEO
        ? pdpVideoCount ? true : productInfo?.panning_video_status
        : pdpVideoCount ? true : productInfo?.ai_video_status,
    [
      activeTab,
      productInfo?.panning_video_status,
      productInfo?.video_status,
      productInfo?.ai_video_status,
      pdpVideoCount,
    ]
  );

  useEffect(() => {
    setActionMenu([
      {
        id: 1,
        title: 'Use this video',
        icon: null,
        onClick: () => handleEnabled(),
        type: 'button',
        loading: false,
        initialValue: isVideoEnabled,
        disabled: pdpVideoCount ? true : false,
      },
      {
        id: 2,
        title: 'Copy Link',
        icon: null,
        onClick: () => handleCopy(),
        disabled: !isVideoEnabled,
      },
      {
        id: 3,
        title: 'Embed on website',
        icon: null,
        onClick: () => handleEmbedding(),
        disabled: !isVideoEnabled,
      },
      {
        id: 4,
        title: 'Download',
        icon: null,
        onClick: () => handleDownload(),
        disabled: !isVideoEnabled,
      },
      {
        id: 5,
        title: 'Note: Once you use this video, it will be deducted from your package.',
        type: 'info',
      },
    ]);
  }, [activeTab, isVideoEnabled, pdpVideoCount]);

  useEffect(() => {
    if (!activeTab) return;
    setActionMenu((prev) => [
      ...prev
        .map((a) => {
          if (a.id === 1 && !isPackProduct) {
            if (isVideoEnabled) return false;

            return {
              ...a,
              initialValue: isVideoEnabled,
            };
          }
          if (a.id === 1 && isPackProduct) return null;

          return {
            ...a,
            disabled: isPackProduct ? false : isVideoEnabled ? false : true,
          };
        })
        .filter(Boolean),
    ]);
  }, [
    activeTab,
    productInfo?.video_status,
    isVideoEnabled,
    loading,
    availableProductCount,
    productUnicodeId,
    orgProductUniqueCodeId,
    isPackProduct,
  ]);

  const onRenameSubmit = async (payload) => {
    const api =
      activeTab.type === LINKED_PRODUCT_DATA.VIDEO
        ? apiUpdateProductVideoInfo
        : activeTab.type === LINKED_PRODUCT_DATA.PANNING_VIDEO
        ? apiUpdateProductPanningVideoInfo
        : apiUpdateProductAIVideoInfo;
    const res = await api(activeTab?.id, payload);
    await getAllVideos();
    if (res?.id) {
      successToast('Video name is successfully updated.');
    } else {
      errorToast('Unable to update video name. Please try again later.');
    }
    refetchDetails?.();
    setRenameEnabled(false);
  };

  const onVideoUploadSubmit = async (files = [], type) => {
    const action = videoUploadModal?.action;
    setLoading(true);
    const result = await Promise.allSettled(
      files.map(async (a) => {
        const payload = new FormData();
        payload.append('assigned_product', productId);
        payload.append('name', a?.name);
        payload.append('description', a?.name);
        payload.append('file_url_key', a?.name?.replaceAll(' ', '_'));
        payload.append('is_pack', true); // isVideoPackProduct

        let response;
        if (action === 'edit') {
          payload.append('status', VIDEO_STATUS.PROCESSING);
          response = await apiUpdateProductPanningVideoInfo(activeTab?.id, payload);
        } else {
          // action === 'add'
          response = await apiUploadProductPanningVideoInfo(payload);
        }

        if (response?.status || response?.id) {
          const presigned_data = response?.data?.presigned_data || response?.presigned_data;
          await apiPostImageOnPresignedData(a?.file, presigned_data);

          // updating video/ai video status to done, once the upload it finished
          const _id = response?.data?.id || response?.id;
          if (_id) {
            const _payload = new FormData();
            _payload.append('status', VIDEO_STATUS.DONE);
            await apiUpdateProductPanningVideoInfo?.(_id, _payload);
          }
        }
        return response;
      })
    );
    await getAllVideos();
    setLoading(false);
    if (result) {
      successToast('Video is uploaded successfully.');
    } else {
      errorToast('Unable to update video. Please try again later.');
    }
    refetchDetails?.();
    setVideoUploadModal(null);
  };

  // if (!activeTab)
  if (filteredVideos.length === 0 && !isEditor) return null;

  const handleChangeVideo = (type) => {
    const { indexValue } = handleGetActiveTabIndex();
    if (type === PRODUCT_PAGE_NAVIGATION_KEY.NEXT) {
      setActiveTab(filteredVideos[indexValue + 1]);
    } else {
      setActiveTab(filteredVideos[indexValue - 1]);
    }
  };

  const handleDisableNavButton = (buttonType) => {
    const { indexValue, count } = handleGetActiveTabIndex();
    if (buttonType === PRODUCT_PAGE_NAVIGATION_KEY.NEXT) {
      return count < indexValue + 1 || count === indexValue + 1 ? true : false;
    } else {
      return indexValue < 1 || indexValue === 0 ? true : false;
    }
  };

  const handleGetActiveTabIndex = () => {
    if (filteredVideos?.length) {
      const indexValue = filteredVideos?.findIndex(({ id }) => +id === +activeTab?.id);
      return { indexValue: indexValue, count: filteredVideos?.length };
    } else {
      return { indexValue: null, count: 0 };
    }
  };

  return (
    <>
      {renameEnabled && isEditor && !isPublicPage ? (
        <ShowRenameModel
          show={true}
          onClose={() => setRenameEnabled(false)}
          activeTab={activeTab}
          onSubmit={onRenameSubmit}
          preventFromClosing={loading}
        />
      ) : null}

      {videoUploadModal?.type && isEditor && !isPublicPage ? (
        <ModalArea
          size="md"
          showModal={Boolean(videoUploadModal?.type)}
          setShowModal={() => (loading ? null : setVideoUploadModal(null))}
          animation={true}
          centered={true}
          title={`${videoUploadModal?.action === 'edit' ? 'Update' : 'Upload'} Video`}
          {...(loading ? { backdrop: 'static' } : {})}
          body={
            <UploadWithItemListModal
              type={videoUploadModal?.type}
              title="Panning Video Upload"
              accept="video/mp4"
              restrictMultiple={true}
              onClick={onVideoUploadSubmit}
              loading={loading}>
              {/* <div className="mt-3 mb-1">
                <Checkbox
                  selected={isVideoPackProduct}
                  onChange={() => setIsVideoPackProduct(!isVideoPackProduct)}
                  label="Pack Product"
                />
              </div> */}
            </UploadWithItemListModal>
          }
        />
      ) : null}

      <div className="video-showcase">
        <div className="life-style-header mt-0">
          <h6 className="main-title text-white">
            Videos{' '}
            <small
              className="d-sm-inline d-block"
              style={{ fontSize: '0.875rem', color: 'rgba(255, 255, 255, 0.75)' }}>
              that you&apos;ll never forget.
            </small>
          </h6>
          <div className="d-flex align-items-center">
            {isEditor && !isPublicPage && !isGuestUser() ? (
              <MenuDropdown
                defaultPrevent
                menu={action3DotMenu}
                isWhite={true}
                handleSelect={handleSelect}
              />
            ) : null}
            {isMobile &&
            !isGuestLogin &&
            !isGuestUser() &&
            (isPackProduct ||
              (!isPackProduct && activeTab?.type !== LINKED_PRODUCT_DATA.PANNING_VIDEO)) ? (
              <ShareButton
                className="share_button small"
                loading={loading}
                onClick={
                  isPublicPage && !currentUser
                    ? () => navigate(SIGN_IN_ROUTE) // SIGNUP_ROUTE // Commenting this code to prevent signup
                    : isVideoEnabled
                    ? null
                    : (!activePlan && availableProductCount === 0) || availableProductCount === 0
                    ? isPackProduct
                      ? false
                      : handleShareForUse
                    : null
                }
                menu={actionMenu}
              />
            ) : null}
          </div>
        </div>
        {isMobile ? (
          <>
            {filteredVideos.map(({ id, url, mpd_file }) => {
              return (
                <VideoSectionUI
                  key={id}
                  active={activeTab?.id === id}
                  id={id}
                  url={isIphoneIOS() ? url || mpd_file : mpd_file || url}
                />
              );
            })}
            <div className="video-footer-navigation">
              <h6>{activeTab?.name}</h6>
              <div className="video-arrow">
                <button
                  disabled={handleDisableNavButton(PRODUCT_PAGE_NAVIGATION_KEY.PREVIOUS)}
                  onClick={() => handleChangeVideo(PRODUCT_PAGE_NAVIGATION_KEY.PREVIOUS)}
                  className={`arrow`}>
                  <LeftIcon />
                </button>
                <button
                  disabled={handleDisableNavButton(PRODUCT_PAGE_NAVIGATION_KEY.NEXT)}
                  onClick={() => handleChangeVideo(PRODUCT_PAGE_NAVIGATION_KEY.NEXT)}
                  className={`arrow`}>
                  <RightIcon />
                </button>
              </div>
            </div>
          </>
        ) : (
          <VideoTabUI
            list={filteredVideos}
            loading={loading}
            setList={setVideoList}
            isEditor={isEditor}
            handleOrder={handleUpdateOrder}
            actionMenu={actionMenu}
            isPublicPage={isPublicPage}
            currentUser={currentUser}
            isVideoEnabled={isVideoEnabled}
            activePlan={activePlan}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            availableProductCount={availableProductCount}
            onShareClick={handleShareForUse}
            isPackProduct={isPackProduct}
          />
        )}
      </div>
    </>
  );
};
